import { CollectionView } from "backbone.marionette";
import * as cells from "common/components/table/cells/_all";

export const HeaderView = CollectionView.extend({
    childViewEventPrefix: "childview",
    childViewEvents: {
        sort(view, cell, order) {
            this.collection.each((model) => {
                if (model.get("sortable") === true) {
                    const attribute = model.get("attribute");
                    
                    // If sort is triggered on this cell then set new order
                    model.set("sortOptions", { ...model.get("sortOptions"), active: attribute === cell ? order : false });
                }
            });
            
            // Remove all sorts from the secondary collection. Locked columns case
            this.getOption("secondaryCollection").each((model) => {
                model.set("sortOptions", { ...model.get("sortOptions"), active: false });
            });
        }
    },
    childView(item) {
        // Choose which view class to render, depending on the properties of the item model
        const cellTypeValue = item.get("cell");
        const cellType = typeof cellTypeValue === "function" ? cellTypeValue(item.toJSON()) : cellTypeValue;
        
        try {
            return cells[cellType].HeaderView;
        } catch {
            throw new Error("Unsupported header view type");
        }
    },
    tagName: "tr"
});
